import type {
  FileTemplate,
  GeneratedFileTemplate,
} from "schemas/generated/fileTemplate";
import type { TemplateItem } from "../CreateNewPage";

import React from "react";

import { WebContainerTemplate } from "@/features/web-container/WebContainerTemplate";

import PagePreviewCard, { PagePreviewCardSkeleton } from "./PagePreviewCard";

export function FileTemplatesList({
  isLoading,
  selectedPageTemplate,
  handlePageTemplateClick,
  fileTemplates,
}: {
  isLoading: boolean;
  selectedPageTemplate: TemplateItem | null;
  handlePageTemplateClick: (templateId: string) => void;
  fileTemplates?: FileTemplate[];
}) {
  const showLoading = isLoading || !fileTemplates;

  if (showLoading) {
    return (
      <>
        {Array.from({ length: 6 }).map((_, index) => (
          <PagePreviewCardSkeleton key={index} />
        ))}
      </>
    );
  }

  return (
    <>
      {fileTemplates.map((template) => (
        <PagePreviewCard
          key={template.id}
          pageData={{
            route: `/template-preview/${template.id}`,
            title: template.name,
            description: template.category,
          }}
          isSelected={selectedPageTemplate?.id === template.id}
          onClick={() => handlePageTemplateClick(template.id)}
        />
      ))}
    </>
  );
}

export function GeneratedFileTemplatesList({
  isLoading,
  selectedPageTemplate,
  handlePageTemplateClick,
  generatedTemplates,
}: {
  isLoading: boolean;
  selectedPageTemplate: TemplateItem | null;
  handlePageTemplateClick: (templateId: string) => void;
  generatedTemplates: GeneratedFileTemplate[];
}) {
  const showLoading = isLoading || generatedTemplates.length === 0;

  if (showLoading) {
    return (
      <>
        {Array.from({ length: 2 }).map((_, index) => (
          <PagePreviewCardSkeleton key={index} hideDescription />
        ))}
      </>
    );
  }

  return (
    <>
      {generatedTemplates.map((template) => (
        <WebContainerTemplate key={template.id} template={template}>
          {({ templateRoute }) => (
            <PagePreviewCard
              pageData={{
                route: templateRoute,
                title: template.name,
                description: undefined,
              }}
              isSelected={selectedPageTemplate?.id === template.id}
              onClick={() => handlePageTemplateClick(template.id)}
            />
          )}
        </WebContainerTemplate>
      ))}
    </>
  );
}
